import { Action, createReducer, on } from '@ngrx/store';
import { listToDictionary } from '@symphony-solo/shared/utils/src';
import { loadPriceLevelsAction, loadPriceLevelsErrorAction, loadPriceLevelsSuccessAction } from './price-levels.actions';
import { PriceLevelsState } from './price-levels.state';

const initialState = new PriceLevelsState();

const reducer = createReducer(
  initialState,
  on(loadPriceLevelsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(loadPriceLevelsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.priceLevels = listToDictionary(payload.priceLevels, 'id');
    return newState;
  }),
  on(loadPriceLevelsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function priceLevelsReducer(state: PriceLevelsState | null, action: Action) {
  return reducer(state, action);
}
